import React, { Component } from 'react';
//import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
//import Card from 'react-bootstrap/Card';
//import Nav from 'react-bootstrap/Nav';
import {
    Table,
    Text,
    keys,
    Group,
    UnstyledButton,
    rem,
    Center,
    Divider,
    Flex,
    Collapse,
    Timeline,
    Space,
    Loader,
    Select,
    Paper,
    Modal,
    Grid
} from '@mantine/core';
import dayjs from 'dayjs';

import { Doughnut } from "react-chartjs-2";

import classes from '../TableSort.module.css';
import { IconSelector, IconChevronDown, IconChevronUp, IconLineDashed } from '@tabler/icons-react';
import HardwareTicketDataService from '../../services/hardware-ticket-activities';
import HoldingTableDataService from '../../services/holding-table-activities';

//import AssignTechsTicketsCalendarService from '../../services/assign-techs_tickets-calendar-activities';

import { REPORT_TENANT_CHANGE_RESOLVED } from '../../features/actions/Is-Logged-Actions';

import { 
    REPORT_RESOLVED_TIMESPAN_CHANGE_RESOLVED, 
    REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED, 
    REPORT_ASSIGNED_TO_CHANGE_RESOLVED, 
    UPDATE_SURVEY_REPORT_OPEN_STATUS,
    UPDATE_SURVEY_SORTING,
    UPDATE_SURVEY_AVERAGE_SORTING
} from '../../features/actions/Reports-Actions';

import { LOGOUT } from '../../features/actions/Is-Logged-Actions';


function Th(props) {
    const Icon = props.sorted ? (props.reversed ? IconChevronUp : IconChevronDown) : IconSelector;
    return (
        <Table.Th className={classes.th}>
            <UnstyledButton onClick={props.onSort} className={classes.timespanReportControl}>
                <Group justify="left"/* justify="space-between" */>
                    <Text fw={800} fz="sm">
                        {props.children}
                    </Text>
                    <Center className={classes.icon}>
                        <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
                    </Center>
                </Group>
            </UnstyledButton>
        </Table.Th>
    );
}

function stringToColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += ("00" + value.toString(16)).slice(-2);
    }
    return color;
}



class SurveyResults extends Component {
    constructor(props)  {
        super(props);

        this.state = {
            resolvedTickets: [],
            itemCount: 0,
            showLoader: false,
            hasRun: false,       // prevents the get data code from running more than once after global state change detected
            sortBy: "id",
            sortOrder: "ASC",

            dataValues: [],      // will contain the data needed for the doughnut average score chart
            backgroundColors: [],
            labels: [],
            averageDataForTable: [],

            specificSurveyNumericalScore: 0,
            specificSurveyExtraDetails: "",
            specificSurveyDate: "",
            specificSurveyAskerName: "",
            specificSurveyTicketTitle: "",
            showSpecificSurvey: false,

            averageTableSortBy: "assigned_tech_name",
            averageTableSortOrder: "ASC",

            grandTotalAverage: 0,
            grandTotalSurveyCount: 0
        }
    }


    componentDidMount() {
        this.setState({
            sortBy: this.props.reportInfo.survey_sort_by,
            sortOrder: this.props.reportInfo.survey_sort_order,
            averageTableSortBy: this.props.reportInfo.survey_average_sort_by,
            averageTableSortOrder: this.props.reportInfo.survey_average_sort_order
        }, () => {
            this.getResolvedTickets();
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.loggedStatus.report_tenant_change_detected && !prevProps.loggedStatus.report_tenant_change_detected) {
            this.props.REPORT_TENANT_CHANGE_RESOLVED();

            // get the new list of resolved tickets
            this.getResolvedTickets();
        }

        if(this.props.reportInfo.report_resolved_timespan_change_detected || this.props.reportInfo.report_timespan_type_change_detected || this.props.reportInfo.report_assigned_to_change_detected) {
            if(this.props.reportInfo.report_resolved_timespan_change_detected && !prevProps.reportInfo.report_resolved_timespan_change_detected) {
                this.props.REPORT_RESOLVED_TIMESPAN_CHANGE_RESOLVED();
                console.log("resolved timespan change detected in child 4");

                this.getResolvedTickets();
            }

            // we don't need to worry about fetching on type change because this table will only show Resolved tickets

            // else if(this.props.reportInfo.report_timespan_type_change_detected && !prevProps.reportInfo.report_timespan_type_change_detected) {
            //     this.props.REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED();
            //     console.log("timespan type change detected in child 3");

            //     this.getResolvedTickets();
            // }

            else if(this.props.reportInfo.report_assigned_to_change_detected && !prevProps.reportInfo.report_assigned_to_change_detected) {
                this.props.REPORT_ASSIGNED_TO_CHANGE_RESOLVED();
                console.log("timespan assigned to change detected in child 4");

                this.getResolvedTickets();
            }
        }
    }


    async getScoreAverages(data) {

        let grandTotalScore = 0;
        let grandTotalCount = 0;
    
        const averages = Object.values(
            data.reduce((acc, item) => {
              const score = Number(item.numerical_satisfaction_score);
          
              // Ignore 0, null, undefined, NaN
              if (!score) return acc;
          
              const techName = item.assigned_tech_name ?? "Unassigned";
          
              if (!acc[techName]) {
                acc[techName] = {
                  assigned_tech_name: techName,
                  total: 0,
                  count: 0
                };
              }
          
              acc[techName].total += score;
              acc[techName].count += 1;
    
              grandTotalScore += score;
              grandTotalCount += 1;
          
              return acc;
            }, {})
          )
            // Safety: remove techs with no valid scores
            .filter(({ count }) => count > 0)
            .map(({ assigned_tech_name, total, count }) => ({
              assigned_tech_name,
              average_score: Math.round((total / count) * 10) / 10,     // round to 1 decimal place
              total_rated: count
            }));
    
          console.log("Here's the averages array", averages);
    
            this.setState({
                grandTotalAverage: grandTotalCount > 0 ? Math.round((grandTotalScore / grandTotalCount) * 10) / 10 : 0,     // round to 1 decimal place
                grandTotalSurveyCount: grandTotalCount
            });
    
          return averages;
    }

    showSpecificSurvey() {
        this.setState({
            showSpecificSurvey: true
        });
    }

    hideSpecificSurvey() {
        this.setState({
            specificSurveyNumericalScore: 0,
            specificSurveyExtraDetails: "",
            specificSurveyDate: "",
            specificSurveyAskerName: "",
            specificSurveyTicketTitle: "",
            showSpecificSurvey: false
        });
    }

    async getSpecificSurveyDetails(ticket_id, dateTimeCreated, asker_name, ticket_title) {

        HardwareTicketDataService.getSpecificSurveyDetails(ticket_id).then(response =>  {
            console.log("Response from get specific survey details: ", response.data);

            this.setState({
                specificSurveyNumericalScore: response.data.results[0].numerical_satisfaction_score,
                specificSurveyExtraDetails: response.data.results[0].extra_satisfaction_feedback,
                specificSurveyDate: dateTimeCreated,
                specificSurveyAskerName: asker_name,
                specificSurveyTicketTitle: ticket_title,
            }, () => this.showSpecificSurvey())
        })
        .catch(e => {
            console.log(e);
        });
    }

    // use the global state value for the selected tenant from the report component to get the necessary resolved ticket info
    getResolvedTickets() {
        this.setState({
            showLoader: true
        });

        console.log("I'm in getResolvedTickets, value of timespan in state is: ", this.props.reportInfo.resolved_timespan);

        if(this.props.reportInfo.resolved_timespan && this.props.reportInfo.timespanAssignedToArray && this.props.reportInfo.resolved_timespan.length > 1) {
            var timespan = [this.props.reportInfo.resolved_timespan[0] ? dayjs(Date.parse(this.props.reportInfo.resolved_timespan[0])).$d : null, this.props.reportInfo.resolved_timespan[1] ? dayjs(Date.parse(this.props.reportInfo.resolved_timespan[1])).$d : null]

            console.log("Timespan in getResolvedTickets: ", timespan);
            // generate the list of id numbers user has requested in the filter drop down
            let requesterIdList = [];

            for(let r = 0; r < this.props.reportInfo.timespanAssignedToArray.length; r++) {
                requesterIdList.push(this.props.reportInfo.timespanAssignedToArray[r].value);
            }

            console.log("List of ids to send: ", requesterIdList);

            
            // hardcoding Resolved because that is the only type of ticket this widget is concerned with at all times
            HardwareTicketDataService.getResolvedTickets(this.props.loggedStatus.report_tenant_id_selected, timespan, "Resolved", requesterIdList, this.props.loggedStatus.id, this.props.loggedStatus.timezone_adjustment_factor)
            .then(async response => {
                console.log("Resolved ticket list returned: ", response);
                let averageData = await this.getScoreAverages(response.data.results);

                // let processedData = {};

                // processedData = Object.entries(averageData)
                // .map(([name, average, total]) => ({ name, average, total }))
                // .sort((a, b) => a.name.localeCompare(b.name));

                //console.log("The processed data for scores is: ", processedData);
                if(averageData !== undefined && averageData !== null) {
                    this.setState({
                        labels: averageData.map((item) => item.assigned_tech_name),
                        dataValues: averageData.map((item) => item.average_score),
                        backgroundColors: averageData.map((item) => stringToColor(item.assigned_tech_name))
                    })
                    //setLabels(processedData.map((item) => item.name));
                    //setDataValues(processedData.map((item) => item.total));
                    //setBackgroundColors(processedData.map((item) => stringToColor(item.average_score)));
                }

                this.setState({
                    resolvedTickets: response.data.results,
                    averageDataForTable: averageData,
                    itemCount: response.data.rowCount,
                    showLoader: false
                }, () => {this.sortTable(this.state.resolvedTickets, this.state.sortBy, this.state.sortOrder); this.sortAverageTable(this.state.averageDataForTable, this.state.averageTableSortBy, this.state.averageTableSortOrder)});
            })
            .catch(e => {
                console.log(e);
            });
        }
    }

    handleReportOpenChange() {
        this.props.UPDATE_SURVEY_REPORT_OPEN_STATUS();     // toggles global state value between true and false
    }

    goToHardwareTicketDetails(id) {
        this.props.history.push(`/hardwareTickets/${id}`);
    }

    goToHoldingTicketDetails(id) {
        this.props.history.push(`/clarifyTicket/${id}`);
    }

    // locally sorts the data displayed in the table based on the column clicked and sort order
    // affects resolvedTickets []
    sortTable(array, sortBy, sortOrder) {
        const sortedArray = [...array].sort((a, b) => {
            let aVal = a[sortBy];
            let bVal = b[sortBy];
        
            // Treat null or undefined assigned_tech_name as "Unassigned"
            if (sortBy === "assigned_tech_name") {
              aVal = aVal ?? "Unassigned";
              bVal = bVal ?? "Unassigned";
            }

            // Treat null or undefined numerical_satisfaction_score as 0 for sorting purposes
            if (sortBy === "numerical_satisfaction_score") {
                aVal = aVal ?? 0;
                bVal = bVal ?? 0;
            }
        
            // For string comparison (case-insensitive)
            if (typeof aVal === "string" && typeof bVal === "string") {
              const result = aVal.toLowerCase().localeCompare(bVal.toLowerCase());
              return sortOrder === "ASC" ? result : -result;
            }
        
            // For number or date comparison
            if (aVal > bVal) return sortOrder === "ASC" ? 1 : -1;
            if (aVal < bVal) return sortOrder === "ASC" ? -1 : 1;
            return 0;
        });

        console.log("here is the sorted array: ", sortedArray);
        
        //return sortedArray;
        this.setState({
            resolvedTickets: sortedArray
        });
    }

    // locally sorts the averageDataForTable
    sortAverageTable(array, sortBy, sortOrder) {
        const sortedArray = [...array].sort((a, b) => {
            let aVal = a[sortBy];
            let bVal = b[sortBy];
        
            // Treat null or undefined assigned_tech_name as "Unassigned"
            if (sortBy === "assigned_tech_name") {
              aVal = aVal ?? "Unassigned";
              bVal = bVal ?? "Unassigned";
            }

            // Treat null or undefined numerical_satisfaction_score as 0 for sorting purposes
            // if (sortBy === "numerical_satisfaction_score") {
            //     aVal = aVal ?? 0;
            //     bVal = bVal ?? 0;
            // }
        
            // For string comparison (case-insensitive)
            if (typeof aVal === "string" && typeof bVal === "string") {
              const result = aVal.toLowerCase().localeCompare(bVal.toLowerCase());
              return sortOrder === "ASC" ? result : -result;
            }
        
            // For number or date comparison
            if (aVal > bVal) return sortOrder === "ASC" ? 1 : -1;
            if (aVal < bVal) return sortOrder === "ASC" ? -1 : 1;
            return 0;
        });

        this.setState({
            averageDataForTable: sortedArray
        });
    }

    // fired when user clicks a table header - sorts resolved tickets by column and flips sort order
    handleSortByAndOrderChange(new_column_name) {

        let newSortOrder;
        if(this.state.sortOrder === "ASC") {
            newSortOrder = "DESC";
        }

        else {
            newSortOrder = "ASC";
        }

        // if this is a new column, change both the column sorted and the order
        if(new_column_name !== this.state.sortBy) {
            this.setState({
                sortBy: new_column_name,
                sortOrder: newSortOrder,
                //offset: 0
            }, () => this.sortTable(this.state.resolvedTickets, new_column_name, newSortOrder));
        }

        // otherwise it was the same column, so just change the sort order
        else {
            this.setState({
                sortOrder: newSortOrder,
                //offset: 0
            }, () => this.sortTable(this.state.resolvedTickets, this.state.sortBy, newSortOrder));
        }

        // update global state for sortBy and sortOrder here
        this.props.UPDATE_SURVEY_SORTING({sortBy: new_column_name});
    }

    // fired when user clicks a table header in the smaller average score table - sorts average data by column and flips sort order
    handleSortByAndOrderChangeAverageTable(new_column_name) {

        let newSortOrder;
        if(this.state.averageTableSortOrder === "ASC") {
            newSortOrder = "DESC";
        }

        else {
            newSortOrder = "ASC";
        }

        // if this is a new column, change both the column sorted and the order
        if(new_column_name !== this.state.averageTableSortBy) {
            this.setState({
                averageTableSortBy: new_column_name,
                averageTableSortOrder: newSortOrder,
                //offset: 0
            }, () => this.sortAverageTable(this.state.averageDataForTable, new_column_name, newSortOrder));
        }

        // otherwise it was the same column, so just change the sort order
        else {
            this.setState({
                averageTableSortOrder: newSortOrder,
                //offset: 0
            }, () => this.sortAverageTable(this.state.averageDataForTable, this.state.averageTableSortBy, newSortOrder));
        }

        // update global state for sortBy and sortOrder here
        this.props.UPDATE_SURVEY_AVERAGE_SORTING({sortBy: new_column_name});
    }


    render() {
        const labels = this.state.labels;
        const chartData = {
            labels,
            datasets: [
              {
                label: "Average Score",
                data: this.state.dataValues,
                backgroundColor: this.state.backgroundColors,
                borderColor: this.state.backgroundColors,
                borderWidth: 1,
              },
            ],
        };
        
        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false
                    /* position: "right",
                    labels: {
                        // Use a function to set label color dynamically
                        color: colorScheme === 'dark' ? theme.colors.gray[0] : theme.black,
                        font: {
                        size: 14,
                        weight: '500',
                        },
                    }, */
                }
            },
        };

        // there won't be any unclarified tickets in this report as only hardware tickets can be resolved
        const rows = this.state.resolvedTickets.map((ticket) => {
            if (ticket.source === "Hardware") {
                return <Table.Tr key={`hardware_${ticket.id}`} onClick={(event) => {event.stopPropagation(); this.getSpecificSurveyDetails(ticket.id, ticket.formatted_date_time_survey_submitted, ticket.asker_name, ticket.ticket_title)}}>
                    <Table.Td w="10%">{`# ${ticket.id}`}</Table.Td>
                    <Table.Td w="11%">{ticket.sla_name ? ticket.sla_name : "Not Yet Set"}</Table.Td>
                    <Table.Td w="16%">{ticket.asker_name}</Table.Td>
                    <Table.Td w="16%">{ticket.assigned_tech_name ? ticket.assigned_tech_name : "Unassigned"}</Table.Td>
                    <Table.Td w="10%">{ticket.formatted_date_time_created}</Table.Td>
                    <Table.Td w="10%">{ticket.formatted_date_time_resolved}</Table.Td>
                    <Table.Td w="20%">{ticket.ticket_title}</Table.Td>
                    <Table.Td w="7%">{ticket.numerical_satisfaction_score !== null ? ticket.numerical_satisfaction_score : "N/A"}</Table.Td>
                </Table.Tr>
            }

            else {
                return <Table.Tr key={`unclarified_${ticket.id}`} onClick={(event) => {event.stopPropagation(); this.goToHoldingTicketDetails(ticket.id)}}>
                    <Table.Td w="14%">{`Temp# ${ticket.id}`}</Table.Td>
                    <Table.Td w="14%">{ticket.sla_name ? ticket.sla_name : "Not Yet Set"}</Table.Td>
                    <Table.Td w="16%">{ticket.asker_name}</Table.Td>
                    <Table.Td w="16%">{ticket.assigned_tech_name ? ticket.assigned_tech_name : "Unassigned"}</Table.Td>
                    <Table.Td w="10%">{ticket.formatted_date_time_created}</Table.Td>
                    <Table.Td w="10%">{ticket.formatted_date_time_resolved}</Table.Td>
                    <Table.Td w="20%">{ticket.ticket_title}</Table.Td>
                </Table.Tr>
            }
        })

        return (
            <>
                <Paper withBorder p="md" radius="md" display="block" m="5px" onClick={() => this.handleReportOpenChange()}>
                    {this.state.showLoader === true ? 
                        <div><Text size="xl" fw={700} component="span">{`Survey Results ( `}</Text><span style={{ display: 'inline-flex', alignItems: 'center' }}><Loader type="dots" color="purple"/></span><Text size="xl" fw={700} component="span">{` )`}</Text>{this.props.reportInfo.survey_report_open ? <IconChevronDown style={{marginLeft: "10px"}}/> : <IconChevronUp style={{marginLeft: "10px"}}/>}</div>
                        :
                        <div><Text size="xl" fw={700} component="span">{`Survey Results ( `}</Text><Text size="xl" fw={700} component="span" c="purple">{`${this.state.itemCount}`}</Text><Text size="xl" fw={700} component="span">{` )`}</Text>{this.props.reportInfo.survey_report_open ? <IconChevronDown style={{marginLeft: "10px"}}/> : <IconChevronUp style={{marginLeft: "10px"}}/>}</div>
                    }
                    <Collapse in={this.props.reportInfo.survey_report_open}>
                        <div style={{ 
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-evenly",
                            gap: "2rem",
                            flexWrap: "wrap", // optional: allows wrapping on smaller screens
                            marginBottom: "30px",
                            marginTop: "30px"
                        }}>
                            <div style={{ width: 200, height: 200 }}>
                                <Doughnut data={chartData} options={options} />
                            </div>
                        
                            <div style={{ flex: 1, maxWidth: 700 }}>
                                <Table>
                                    <Table.Thead>
                                        <Table.Tr>
                                            <Th 
                                                w="50%"
                                                sorted={this.state.averageTableSortBy === 'assigned_tech_name'}
                                                reversed={this.state.averageTableSortOrder === "ASC"}
                                                onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChangeAverageTable("assigned_tech_name")}}
                                                style={{cursor: "pointer"}}
                                            >
                                                <div className={this.state.averageTableSortBy === "assigned_tech_name" ? "activeMyAssignedTicketsHeader" : ""}>Name</div>
                                                {/* <div>Name</div> */}
                                            </Th>
                                            <Th 
                                                w="25%"
                                                sorted={this.state.averageTableSortBy === 'average_score'}
                                                reversed={this.state.averageTableSortOrder === "ASC"}
                                                onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChangeAverageTable("average_score")}}
                                                style={{cursor: "pointer"}}
                                            >
                                                <div className={this.state.averageTableSortBy === "average_score" ? "activeMyAssignedTicketsHeader" : ""}>Average Score</div>
                                                {/* <div>Average Score</div> */}
                                            </Th>
                                            <Th
                                                w="25%"
                                                sorted={this.state.averageTableSortBy === 'total_rated'}
                                                reversed={this.state.averageTableSortOrder === "ASC"}
                                                onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChangeAverageTable("total_rated")}}
                                            >
                                                <div className={this.state.averageTableSortBy === "total_rated" ? "activeMyAssignedTicketsHeader" : ""}>Total Rated</div>
                                                {/* <div>Total Rated</div> */}
                                            </Th>
                                        </Table.Tr>
                                    </Table.Thead>
                                    <Table.Tbody>
                                        {this.state.averageDataForTable && this.state.averageDataForTable.map((item, idx) => (
                                            <Table.Tr key={`${item.assigned_tech_name}-${idx}`}>
                                                <Table.Td w="50%">{item.assigned_tech_name}</Table.Td>
                                                <Table.Td w="25%">{item.average_score}</Table.Td>
                                                <Table.Td w="25%">{item.total_rated}</Table.Td>
                                            </Table.Tr>
                                        ))}
                                        <Table.Tr key={`grandTotalRow`}>
                                            <Table.Td w="50%" c="cyan" fw={700}>Grand Total</Table.Td>
                                            <Table.Td w="25%" c="cyan" fw={700}>{this.state.grandTotalAverage}</Table.Td>
                                            <Table.Td w="25%" c="cyan" fw={700}>{this.state.grandTotalSurveyCount}</Table.Td>
                                        </Table.Tr>
                                    </Table.Tbody>
                                </Table>
                            </div>
                        </div>
                        <Table highlightOnHover="true" style={{ cursor: "pointer" }}>
                            <Table.Thead>
                                <Table.Tr>
                                    <Th 
                                        w="10%"
                                        sorted={this.state.sortBy === 'id'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("id")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "id" ? "activeMyAssignedTicketsHeader" : ""}>ID</div>
                                    </Th>
                                    <Th 
                                        w="11%"
                                        sorted={this.state.sortBy === 'sla_name'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("sla_name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "sla_name" ? "activeMyAssignedTicketsHeader" : ""}>Priority</div>
                                    </Th>
                                    <Th 
                                        w="16%"
                                        sorted={this.state.sortBy === 'asker_name'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("asker_name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "asker_name" ? "activeMyAssignedTicketsHeader" : ""}>Requester</div>
                                    </Th>
                                    <Th 
                                        w="16%"
                                        sorted={this.state.sortBy === 'assigned_tech_name'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("assigned_tech_name")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "assigned_tech_name" ? "activeMyAssignedTicketsHeader" : ""}>Assigned To</div>
                                    </Th>
                                    <Th 
                                        w="10%"
                                        sorted={this.state.sortBy === 'formatted_date_time_created'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("formatted_date_time_created")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "formatted_date_time_created" ? "activeMyAssignedTicketsHeader" : ""}>Time Created</div>
                                    </Th>
                                    <Th
                                        w="10%"
                                        sorted={this.state.sortBy === 'formatted_date_time_resolved'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("formatted_date_time_resolved")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "formatted_date_time_resolved" ? "activeMyAssignedTicketsHeader" : ""}>Time Resolved</div>
                                    </Th>
                                    <Th
                                        w="20%"
                                        sorted={this.state.sortBy === 'ticket_title'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("ticket_title")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "ticket_title" ? "activeMyAssignedTicketsHeader" : ""}>Title</div>
                                    </Th>
                                    <Th
                                        w="7%"
                                        sorted={this.state.sortBy === 'numerical_satisfaction_score'}
                                        reversed={this.state.sortOrder === "ASC"}
                                        onSort={(event) => {event.stopPropagation(); this.handleSortByAndOrderChange("numerical_satisfaction_score")}}
                                        style={{cursor: "pointer"}}
                                    >
                                        <div className={this.state.sortBy === "numerical_satisfaction_score" ? "activeMyAssignedTicketsHeader" : ""}>Score</div>
                                    </Th>
                                </Table.Tr>
                            </Table.Thead>
                        {/* </Table> */}
                        {/* <Table highlightOnHover="true" style={{ cursor: "pointer" }}> */}
                        {this.props.reportInfo.survey_report_open ? 
                            <Table.Tbody>
                                {rows && rows.length > 0 ? (
                                    rows
                                ) : (
                                    <Table.Tr>
                                        <Table.Td colSpan={7}>
                                            <Text fw={500} ta="center">
                                                Nothing found
                                            </Text>
                                        </Table.Td>
                                    </Table.Tr>
                                )}
                            </Table.Tbody>
                            :
                            undefined
                        }
                        </Table>
                    </Collapse>
                </Paper>

                {/* This modal is to confirm that the ticket should END on hold status */}
                <Modal
                    opened={this.state.showSpecificSurvey}
                    onClose={() => { this.hideSpecificSurvey() }}
                    size="xl"
                    centered
                    title="Survey Details"
                    styles={{
                        title: {
                            width: '100%',
                            textAlign: 'center',
                        },
                    }}
                    withCloseButton={true}
                >
                    
                        {/* <div>Numerical Score</div>
                        <div>{this.state.specificSurveyNumericalScore}</div> */}
                        <Table withRowBorders={false} style={{cursor: "default", width: "100%", tableLayout: "fixed"}}>
                            <Table.Tbody>
                                <Table.Tr>
                                    <Table.Td style={{width: "20%"}}>Creator</Table.Td>
                                    <Table.Td style={{width: "80%"}}>{this.state.specificSurveyAskerName}</Table.Td>
                                </Table.Tr>
                                <Table.Tr>
                                    <Table.Td style={{width: "20%"}}>Ticket Title</Table.Td>
                                    <Table.Td style={{width: "80%"}}>{this.state.specificSurveyTicketTitle}</Table.Td>
                                </Table.Tr>
                                <Table.Tr>
                                    <Table.Td style={{width: "20%"}}>Date Submitted</Table.Td>
                                    <Table.Td style={{width: "80%"}}>{this.state.specificSurveyDate}</Table.Td>
                                </Table.Tr>
                                <Table.Tr>
                                    <Table.Td style={{width: "20%"}}>Numerical Score</Table.Td>
                                    <Table.Td style={{ width: "80%" }}>{this.state.specificSurveyNumericalScore}</Table.Td>
                                </Table.Tr>
                                <Table.Tr>
                                    <Table.Td style={{width: "20%"}}>Extra Feedback</Table.Td>
                                    <Table.Td style={{width: "80%"}}>{this.state.specificSurveyExtraDetails}</Table.Td>
                                </Table.Tr>
                            </Table.Tbody>
                        </Table>
                    
                </Modal>
            </>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        loggedStatus: state.logged,
        activeNavLinkStatus: state.activeNav,    // Use global state to control which link is highlighted
        reportInfo: state.reports
    };
}

export default connect(mapStateToProps, { 
    UPDATE_SURVEY_REPORT_OPEN_STATUS, 
    UPDATE_SURVEY_SORTING,
    UPDATE_SURVEY_AVERAGE_SORTING,
    REPORT_TENANT_CHANGE_RESOLVED, 
    REPORT_RESOLVED_TIMESPAN_CHANGE_RESOLVED, 
    REPORT_TIMESPAN_TYPE_CHANGE_RESOLVED, 
    REPORT_ASSIGNED_TO_CHANGE_RESOLVED, /* UPDATE_RESOLVED_TICKET_REPORT_OPEN_STATUS, UPDATE_RESOLVED_SORTING */ 
    LOGOUT
})(SurveyResults);